module.exports = __webpack_public_path__ + "static/media/bonbon.f65acbae.svg";